import TopSection from "../../LT/TopSection"
import ExtractForecastFilterScreens from "./ExtractForecastFilterScreens";
import dropdownData from "./ExtractForecastDataResponse.json";
import { Box, Typography, TextField, Checkbox, FormControlLabel } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DatePicker from "../../../components/common/DatePicker";
import { useState } from "react";
import dayjs from 'dayjs';

export const ExtractForecastFromSAP = () => {
    const defaultFromDate = dayjs();
    const defaultToDate = defaultFromDate.add(1, "year");

    const [selectedTimePeriodFrom, setSelectedTimePeriodFrom] = useState(defaultFromDate);
    const [selectedTimePeriodTo, setSelectedTimePeriodTo] = useState(defaultToDate);
    const [noOfWeeks, setNoOfWeeks] = useState('');
    const [sendEmailToPlanner, setSendEmailToPlanner] = useState(false);
    const currentMonthStart = dayjs().startOf('month');
    const currentMonthToday = dayjs().startOf('day');

    const handleDateChangeFrom = (date) => {
        console.log("Selected date From:", date);
        setSelectedTimePeriodFrom(date);
         setSelectedTimePeriodTo(date?.add(1, "year"));
    };
    const handleDateChangeTo = (date) => {
        // console.log("Selected date To:", date);
        setSelectedTimePeriodTo(date);
    };
    const onRenderClearCallback = () => {
        // console.log("Clear callback executed");
    }
    const onRenderExecuteCallback = (filters) => {
        // console.log("Execute callback executed with filters:", filters);
    };

    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Extract Forecast From SAP" },
                ]}
                tabTitle="Extract Forecast From SAP"
            />
            <div>
                <ExtractForecastFilterScreens dropdownData={dropdownData} onRenderClearCallback={onRenderClearCallback} onRenderExecuteCallback={onRenderExecuteCallback} />
            </div>
            <div style={{ marginTop: 20 }}>
                <Typography sx={{ fontSize: 16, fontWeight: 500 }}>Forecast Time Horizon</Typography>
                <div>
                    <div >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '50%', marginTop: 10 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div style={{ display: 'flex', alignItems: 'center', }}>
                                    <p style={{ marginRight: 100, fontSize: 13 }}>Time Period</p>
                                    <DatePicker
                                        name="Starting From"
                                        value={selectedTimePeriodFrom} // Ensure it's a dayjs object
                                        onChange={handleDateChangeFrom}
                                        height="30px"
                                        width={150}
                                        fontSize={13}
                                        fontWeight="normal"
                                        styles={{
                                            fontSize: '12px',
                                            fontWeight: 'normal',
                                        }}
                                        minDate={currentMonthStart}  // Disable previous months
                                    // maxDate={nextMonthEnd}  // Allow only dates from current to next month
                                    />
                                </div>
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <p style={{ marginRight: 10, fontSize: 13 }}>To</p>
                                    <DatePicker
                                        name="TimePeriodTo"
                                        value={selectedTimePeriodTo} // Ensure it's a dayjs object
                                        onChange={handleDateChangeTo}
                                        height="30px"
                                        width={150}
                                        fontSize={13}
                                        fontWeight="normal"
                                        styles={{
                                            fontSize: '12px',
                                            fontWeight: 'normal',
                                        }}
                                        minDate={selectedTimePeriodFrom}
                                    />
                                </div>
                            </LocalizationProvider>
                        </div>

                    </div>
                    {/* <div>
                        <div style={{ display: 'flex', alignItems: 'center', }}>
                            <p style={{ marginRight: 36, fontSize: 13 }}>Weeks to send to Ariba</p>
                            <TextField
                                value={noOfWeeks}
                                onChange={(e) => {
                                    setNoOfWeeks(e.target.value);
                                }}
                                sx={{
                                    width: 150,
                                    '& .MuiInputBase-root': {
                                        height: 30, // same like DatePicker height
                                    },
                                }}
                            />
                        </div>
                    </div> */}
                    <div style={{ marginTop: 10 }}>
                        <FormControlLabel
                            sx={{
                                '& .MuiFormControlLabel-label': {
                                    fontSize: '13px',
                                },
                            }}
                            control={
                                <Checkbox
                                    checked={sendEmailToPlanner}
                                    onChange={(e) => setSendEmailToPlanner(e.target.checked)}
                                    sx={{ fontSize: 13 }}
                                />
                            }
                            label="Send email to Planner"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}